import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isDSNData, isServiceSuccess, ServiceResult } from '@/data.types';

interface Props {
  data: ServiceResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'link-display',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
};



const dishes = computed(() => {
  if (isServiceSuccess(props.data) && isDSNData(props.data.data)) {
    return props.data.data.data.dishes
  }

  return []
})

return { __sfc: true,props, dishes }
}

})